import { CompanyStateRegistration } from '../components';
import { useCompanyStateRegistration } from '../hooks';
import { PageComponentProps } from '../types';

export const CompanyStateRegistrationStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    files,
    goToBack,
    initialValues,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    submitDisabled,
    submitLoading,
  } = useCompanyStateRegistration();

  return (
    <CompanyStateRegistration
      enabledLastStateReRegistrationDate
      canGoBack={canGoBack}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
